import styled from "styled-components";

interface ISwitchCheckbox {
  checked: boolean;
}

const WIDTH = 51;
const SIZE = 27;
const GAP = 2;

export const SwitchCheckbox = styled("div")<ISwitchCheckbox>`
  display: inline-block;
  position: relative;
  width: ${WIDTH}px;
  height: ${2 * GAP + SIZE}px;
  border-radius: ${GAP + 0.5 * SIZE}px;
  background-color: ${({ checked, theme }) => theme.colors[checked ? "sp-blue" : "sp-gray2"]};
  transition: all 0.4s;

  &:after {
    position: absolute;
    content: ' ';
    top: ${GAP}px;
    left: ${({ checked }) => (checked ? `${WIDTH - (SIZE + GAP)}px` : `${2 * GAP}px`)};
    width: ${SIZE}px;
    height: ${SIZE}px;
    border-radius: 50%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .24);
    background-color: #fff;
    transition: inherit;
    z-index: 1;
  }
`;
